var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[[_c('span',[_c('el-popover',{ref:"hint",attrs:{"placement":"top-start","width":"500","trigger":"hover","content":_vm.hint}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('img',{style:(_vm.getStyle()),attrs:{"src":_vm.path}})])])],1)]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ae0a71","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/shared/medals/club/decider/decider.html
// module id = null
// module chunks = 